import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import FilesInput from '../common/components/formInputs/FilesInput'
import TextInput from '../common/components/formInputs/TextInput'
import SelectInput from '../common/components/formInputs/SelectInput'
import TextareaInput from '../common/components/formInputs/TextareaInput'
import ImageInput from '../common/components/formInputs/ImageInput'
import { AVAILABLE_FILE_EXTENSIONS, MAX_FILES_NUMBER } from '../common/helpers'

const FirstStep = ({ displayStep, buildingOptions, formValues, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])
  const selectedBuilding = useSelector(selectActiveBuilding)
  const selectedBuildingId = selectedBuilding ? selectedBuilding.id : null

  useEffect(() => {
    if (formValues.building) {
      return
    }

    const defaultBuilding = buildingOptions.find((option) => option.id === selectedBuildingId)

    if (!defaultBuilding) {
      return
    }

    setFieldValue('building', defaultBuilding)
  }, [selectedBuildingId, formValues, buildingOptions])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <div className="columns">
        <SelectInput
          columnSize={12}
          name="building"
          label={t('eventManagement:reminderFormPage.firstStep.buildingLabel')}
          options={buildingOptions}
          value={formValues.building}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <TextInput
          columnSize={12}
          name="name"
          label={t('eventManagement:reminderFormPage.firstStep.nameLabel')}
          placeholder={t('eventManagement:reminderFormPage.firstStep.namePlaceholder')}
          value={formValues.name}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <TextareaInput
          columnSize={12}
          name="description"
          label={t('eventManagement:reminderFormPage.firstStep.descriptionLabel')}
          placeholder={t('eventManagement:reminderFormPage.firstStep.descriptionPlaceholder')}
          value={formValues.description}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <ImageInput
          columnSize={12}
          name="image"
          value={formValues.image}
          eventName={formValues.name}
          eventType="Reminder"
          setFieldValue={setFieldValue}
        />
      </div>
      <div className="columns">
        <FilesInput
          columnsSize={12}
          label={t('eventManagement:reminderFormPage.firstStep.additionalAssetsLabel')}
          files={formValues.files}
          handleFieldChange={(e) => setFieldValue('files', e.target.value)}
          accept={AVAILABLE_FILE_EXTENSIONS}
          maxNumberOfFiles={MAX_FILES_NUMBER}
          maxFileSizeInMB={3}
        />
      </div>
    </React.Fragment>
  )
}

FirstStep.propTypes = {
  displayStep: PropTypes.bool,
  buildingOptions: PropTypes.array,
  formValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
}

export default FirstStep
